module.exports = __webpack_public_path__ + "static/media/worth-text-img.fbcbdd0d.png";